export const seriesPagePath = '/series'
export const termsIframeWidth = '800'
export const termsIframeHeight = '600'
export const homeRowId = 'SERIES'
export const homeInitialRowIndex = '0'
export const homeRowsCount = 30
export const ZERO_ROW = 'zero row'
export const SeriesPageType = 'SeriesPage'
